import { t } from '@lingui/macro';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { onChangeMapFilters } from '../../../ac/onChangeMapFilters';
import { StandardRadioGroup } from '../StandardRadioGroup';
import { LegendRenderer } from '../../LegendRenderer';
import { AGG_USER_TAPS_ZERO_STARTS_LEGEND_7DAYS, AGG_USER_TAPS_ZERO_STARTS_LEGEND_30DAYS } from '../../../constants/legends';
import * as V from '../../../constants/variables';
import styles from '../FilterSidebar.module.css';

const TapsNoStartsFilterComponent = ({ tapsNoStartsDays, onChangeMapFilters }) => {
    const filterValue = tapsNoStartsDays;
    const onChange = ({ target: { value } }) => {
        const key = 'tapsNoStartsDays';
        onChangeMapFilters(key, +value);
    };
    const legendConfig = filterValue === 7 ? AGG_USER_TAPS_ZERO_STARTS_LEGEND_7DAYS : AGG_USER_TAPS_ZERO_STARTS_LEGEND_30DAYS;

    return (
        <div>
            <div className={styles.legHead}>
                {t`Агрегированные тапы пользователей без поездок`}
            </div>
            <StandardRadioGroup
                value={String(filterValue)}
                onChange={onChange}
            >
                {
                    V.userTapsFilterValues.map(value => (
                        <FormControlLabel
                            key={value}
                            className={styles.isochroneFilterLabel}
                            control={
                                <Radio
                                    checked={filterValue === value}
                                    onChange={onChange}
                                    value={String(value)}
                                    className={classnames(
                                        styles.isochroneFilterInput, {
                                            [styles.checkedIsochroneFilterInput]: filterValue === value,
                                        }
                                    )}
                                    size='small'
                                />
                            }
                            label={t`${value} дней`}
                            labelPlacement='end'
                        />
                    ))
                }
            </StandardRadioGroup>
            <LegendRenderer config={legendConfig} />
        </div>
    );
};
const mapStateToProps = ({ mapFilters: { tapsNoStartsDays } }) => ({
    tapsNoStartsDays,
});
const ConnectedComponent = connect(mapStateToProps, { onChangeMapFilters })(TapsNoStartsFilterComponent);

export const TapsNoStartsFilter = withDisplayedLayersCheck(ConnectedComponent, 'Тапы пользователей без поездок');
